import { createAsyncThunk } from '@reduxjs/toolkit';
import sanityClient from '../../../lib/sanityClient';

export const fetchAbout = createAsyncThunk(
    'about/fetch',
    sanityClient.getAbout
);
